import React, { PropTypes } from 'react'

import data from '../../../core/data';

class aboutOmniderm extends React.Component {
  render () {
    const body1 = data.about.body1;
    const body2 = data.about.body2;
    const body3 = data.about.body3;
    return (
      <section id="about-omniderm">
        <div className="container">
          <div className="row image-bg">
              <h1 className="uppercase">About Omniderm</h1>
              <p>{ body1 }</p>
              <p>{ body2 }</p>
              <p>{ body3 }</p>
          </div>
        </div>
      </section>
    )
  }
}

export default aboutOmniderm;



/** WEBPACK FOOTER **
 ** ./src/components/containers/about/AboutOmniderm.jsx
 **/